"use strict"

function invertPermutation(pi, result) {
  result = result || new Array(pi.length)
  for(var i=0; i<pi.length; ++i) {
    result[pi[i]] = i
  }
  return result
}

module.exports = invertPermutation


//////////////////
// WEBPACK FOOTER
// ./node_modules/invert-permutation/index.js
// module id = 0OLx
// module chunks = 0